import { render } from "./Script.vue?vue&type=template&id=dfafaf5a&scoped=true"
import script from "./Script.vue?vue&type=script&lang=js"
export * from "./Script.vue?vue&type=script&lang=js"

import "./Script.vue?vue&type=style&index=0&id=dfafaf5a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfafaf5a"]])

export default __exports__